import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

export interface ConsultaIpiResultado {
    ncm: string;
    descricao: string;
    aliquotaOriginal: number | null;
    aliquotaIncentivo: number | null;
    tributacao: string;
    moeda: 'USD';
    fonte: string;
    atualizadoEm: string;
    observacoes: string[];
}

export interface ComparativoIpiItem {
    ncm: string;
    pn: string | null;
    apeId: number;
    ipiEntradaProduto: number | null;
    ipiSaidaProduto: number | null;
    ipiEntradaFiscalNcm: number | null;
    ipiSaidaFiscalNcm: number | null;
    aliquotaReceitaOriginal: number | null;
    aliquotaReceitaIncentivo: number | null;
    situacaoReceita: 'OK' | 'NAO_ENCONTRADO' | 'EXIGE_ENQUADRAMENTO';
    observacao: string | null;
}

export interface ComparativoIpiResposta {
    totalNcmsFiscalNcm: number;
    idInicial: number;
    idFinal: number;
    produtosEncontradosNoIntervalo: number;
    totalLinhas: number;
    itens: ComparativoIpiItem[];
}

@Injectable({providedIn: 'root'})
export class ConsultaIpiService {
    constructor(private readonly http: HttpClient) {}

    consultar(ncm: string) {
        return this.http.get<ConsultaIpiResultado>(`/api/sankhya/consultar-ipi/${encodeURIComponent(ncm)}`);
    }

    /**
     * Comparativo em massa: parte dos NCMs distintos da FISCAL_NCM (Aerosys),
     * consulta a alíquota da TIPI pra cada um e busca, PRODUTO POR PRODUTO
     * (não pela listagem genérica, que quebra inteira se um produto tiver
     * dado órfão), os produtos com APE_ID entre idInicial e idFinal que usam
     * algum desses NCMs. Chamado em pedaços pela tela (ver ConsultarIpiComponent).
     */
    compararComAerosys(idInicial: number, idFinal: number) {
        return this.http.get<ComparativoIpiResposta>('/api/sankhya/consultar-ipi/comparativo-aerosys', {
            params: {idInicial, idFinal}
        });
    }
}
